import { CurrencyRateDetails } from 'further-types/lp/transaction';
import ConfirmDialog from 'further-ui/components/ConfirmDialog';
import { Disclosure } from 'further-ui/hooks';
import { FC } from 'react';

type Props = {
  disclosure: Disclosure;
  fxRate: CurrencyRateDetails | null;
  onRateChange: (rate: CurrencyRateDetails) => void;
};

const CancelCustomRateDialog: FC<Props> = ({
  disclosure,
  onRateChange,
  fxRate,
}) => {
  return (
    <ConfirmDialog
      open={disclosure.isOpen}
      onClose={disclosure.onClose}
      title="Warning"
      content="Reverting to the live FX feed will delete any manual FX data input for this transaction. This step cannot be undone."
      actions={{
        confirm: {
          label: 'Revert to live feed',
          onClick: () => {
            onRateChange({
              ...(fxRate ?? {}),
              overrideRate: undefined,
              overrideSource: undefined,
            });
            disclosure.onClose();
          },
        },
        cancel: {
          label: 'Go back',
          onClick: disclosure.onClose,
        },
      }}
    />
  );
};

export default CancelCustomRateDialog;
